import { parseMp3FrameHeader } from "@/utils/audio/mp3/parseMp3FrameHeader";

const isId3v2Tag = (bytes: Uint8Array, offset: number): boolean => {
  return (
    bytes[offset] === 0x49 &&
    bytes[offset + 1] === 0x44 &&
    bytes[offset + 2] === 0x33
  );
};

const isId3v1Tag = (bytes: Uint8Array, offset: number): boolean => {
  return (
    bytes[offset] === 0x54 &&
    bytes[offset + 1] === 0x41 &&
    bytes[offset + 2] === 0x47
  );
};

// What may legitimately follow a frame: the next frame, or either kind of ID3 tag (files joined with cat carry the first file's trailing ID3v1 tag and the second file's leading ID3v2 tag mid-stream). A header that no boundary follows is a false sync inside junk bytes, and both the frame measurer and the backing-track MP3 sniffer skip it the way a decoder resyncs.
export const isMp3FrameBoundary = (
  bytes: Uint8Array,
  offset: number
): boolean => {
  return (
    parseMp3FrameHeader(bytes, offset) !== null ||
    isId3v2Tag(bytes, offset) ||
    isId3v1Tag(bytes, offset)
  );
};
